import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 10 10"
        ref={ref}
        {...props}
    >
        <g clipPath="url(#ursa-icon__ExclamationOnDotIcon__10__ida)">
            <path
                fill="var(--sds--ursa-icons--inner-shape-color, transparent)"
                d="M5.583 5.167a.583.583 0 1 1-1.166 0V3.083a.583.583 0 1 1 1.166 0zM5 7.5a.625.625 0 1 1 0-1.25.625.625 0 0 1 0 1.25"
            />
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M0 5a5 5 0 1 1 10 0A5 5 0 0 1 0 5m5 .75a.583.583 0 0 0 .583-.583V3.083a.583.583 0 1 0-1.166 0v2.084c0 .322.26.583.583.583m-.625 1.125a.625.625 0 1 0 1.25 0 .625.625 0 0 0-1.25 0"
                clipRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="ursa-icon__ExclamationOnDotIcon__10__ida">
                <path fill="#fff" d="M0 0h10v10H0z" />
            </clipPath>
        </defs>
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
